import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "49.815",
  viewBox: "0 0 49.815 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M25.006 0c8.268 0 16 4.15 20.6 10.71v-7.8h4.21v14.64h-14.94v-4.212h7.4C38.458 7.822 31.858 4.21 25.006 4.21 13.54 4.21 4.216 13.538 4.216 25s9.325 20.79 20.79 20.79c8.43 0 15.97-5.03 19.205-12.816l3.89 1.614C44.208 43.95 35.144 50 25.004 50 11.217 50 0 38.785 0 25 0 11.216 11.217 0 25.002 0z"
  })]
});